/* eslint-disable camelcase */ 

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_stay_motivated_by_customizing_and_tracking_your_daily_yoga_routine_collect_certificates_for_and: Phrase =locale => {
  const en = `Stay motivated by customizing and tracking your daily yoga routine. Collect certificates for the courses and challenges you complete. Apple Health integration lets you track how your practice improves your health and well being.`;
  const phrases: { [key: string]: undefined | string } = {
    en, 
    es: `Mantente motivado personalizando y siguiendo tu rutina diaria de yoga. Consigue certificados por los cursos y retos que completes. La integración con Apple Health te permitirá hacer un seguimiento de cómo tu práctica mejora tu salud y bienestar.`,
  };
  return phrases[locale] || en;
};
            